import baseRequest from "../_core/baseRequest";

export default {
    downloadInvoice: params => baseRequest.download(`/logo/invoice/download`, params, true)
};
